import * as actionTypes from '../actions/actionTypes';
const initState = {
    entities: [],
    savedSow: {},
    sowBodyTabs: {
        customerDetailsTab: {
            disabled: false,
            isComplete: false,
        },
        glsTab: {
            disabled: false,
            isComplete: false
        },
        sowDocumentationTab: {
            disabled: false,
            isComplete: false
        },
        customerBasicDetailsTab: {
            disabled: false,
            isComplete: false,
        },
        customerAccountDetailsTab: {
            disabled: false,
            isComplete: false,
        },
        activeTabId: 0,
        customerDetailsActiveTabId: 0
    },
    sowAgent: {},
    sowAllProducts: {},
    selectedSowProduct: {},
    allAccounts: []
}
export default function sowEntities(state = initState, action) {
    switch (action.type) {
        case actionTypes.SET_SOW_ENTITY_LIST: {
            return { ...state, entities: [...action.entities] };
        }
        case actionTypes.SET_SAVED_SOW: {
            return { ...state, savedSow: { ...action.data } }
        }
        case actionTypes.SET_SOW_TAB_STATUS: {
            return { ...state, sowBodyTabs: { ...state.sowBodyTabs, [action.tabName]: { ...action.data } } }
        }
        case actionTypes.SET_SOW_TAB_INDEX: {
            return { ...state, sowBodyTabs: { ...state.sowBodyTabs, [action.tabName]: action.index } }
        }
        case actionTypes.RESET_SOW_ENTITIES: {
            return { ...state, entities: [], savedSow: {} }
        }
        case actionTypes.SET_SOW_AGENT: {
            return { ...state, sowAgent: action.data }
        }
        case actionTypes.SET_SOW_ALLPRODUCTS: {
            return { ...state, sowAllProducts: { ...action.data } }
        }
        case actionTypes.SET_SOW_PRODUCT: {
            return { ...state, selectedSowProduct: { ...action.data } }
        }
        case actionTypes.SET_SOW_PRODUCT_ALL_ACCOUNTS: {
            return { ...state, allAccounts: [...action.data] }
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/createASow/reducers/sowEntities.js